
import { APIErrorFormat } from '@/types/Errors'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class Message extends Vue {
  @Prop({ default: 'Mensaje' })
  title: string
  @Prop({ default: 'Descripción del mensaje' })
  message: string
  @Prop({ default: 5000 })
  delay: number
}

@Component({})
export class MessageErrorHandling extends Message {
  @Prop({ required: true })
  error: any

  /**
   * Creates a new element with base in API response error.
   * Present error format response on API Users is:
   * {
   *  message: ...
   *  description: ...
   *  httpErrorResponse: ...
   * }
   * But in future this will be change to:
   * {
   *  message: ...
   *  httpError: ...
   *  errors: [
   *    ... // List of errors
   *  ]
   * }
   * So, this manage both cases.
   * @param data - API response
   * @returns VNode component with error(s) description(s)
   */
  manageDescription (error: APIErrorFormat) {
    let errorElement = null
    let h = this.$createElement
    if (error.isNewErrorFormat()) {
      // Future error format
      let errors: any[] = []
      error.errors.forEach((e: any) => {
        errors.push(h('p', e.description))
      })
      errorElement = h('div', errors)
    } else if (error.isOldErrorFormat()) {
      // Present error format
      errorElement = h('p', error.description)
    }
    return errorElement || 'Sin descripción'
  }

  /** Returns the message of the error */
  manageMessage (error: APIErrorFormat) {
    return error.message || 'Sin detalle'
  }

  /**
   * Creates a VNone component to display the error info,
   * this is created by $crateElement
   * @returns VNode component
   */
  errorTemplate () {
    let response = this.error.response
    let apiError: APIErrorFormat = APIErrorFormat.getInstance(response.data)
    let errorDescription = this.manageDescription(apiError)
    let errorMessage = this.manageMessage(apiError)
    let requestId = response.headers && response.headers['request-id']
      ? response.headers['request-id']
      : 'Sin identificador'
    // Use a shorter name for this.$createElement
    let h = this.$createElement
    let errorTemplate = h(
      'div',
      [
        h('strong', 'Mensaje: '), h('p', errorMessage),
        h('strong', 'Detalle(s): '), errorDescription,
        h('p'),
        h('small', { class: 'align-bottom' }, `Id: ${requestId}`)
      ]
    )
    return errorTemplate
  }

  /**
   * Launch a toast component to show the error template
   */
  displayMessage () {
    let format = this.errorTemplate()
    this.$bvToast.toast(format, {
      title: this.title,
      variant: 'danger',
      toaster: 'b-toaster-top-center',
      solid: true,
      autoHideDelay: this.delay
    })
  }
}

@Component({})
export class MessageSuccessHandling extends Message {
  displaMessage () {
    this.$bvToast.toast(this.message, {
      title: this.title,
      variant: 'success',
      toaster: 'b-toaster-top-center',
      solid: true,
      autoHideDelay: this.delay
    })
  }
}

export { MessageErrorHandling as MessageError }
export { MessageSuccessHandling as MessageSuccess }
